module.exports = __webpack_public_path__ + "3c4edee93782c0c3b11c8f64aeba0988.png";